import * as THREE from 'three';

export const rotateAroundCenter = (
    group: THREE.Mesh | THREE.Sprite,
    angle: number
) => {
    const box = new THREE.Box3().setFromObject(group);
    const oldCenter = box.getCenter(new THREE.Vector3());

    group.rotation.z += angle;
    group.rotation.y += angle;

    const newBox = new THREE.Box3().setFromObject(group);
    const newCenter = newBox.getCenter(new THREE.Vector3());

    const offset = newCenter.clone().sub(oldCenter);
    group.position.sub(offset);
    group.updateMatrixWorld();
};
